import type { StatusTone } from '@/components/common';
import type { SelectOption } from '@/components/forms';

import type { CompanySize, CompanyStatus } from './types/company.types';

/** Human labels for the backend `CompanySize` enum (SCREAMING_SNAKE → friendly copy). */
export const COMPANY_SIZE_LABELS: Record<CompanySize, string> = {
  STARTUP: 'Startup',
  SMALL: 'Small',
  MEDIUM: 'Medium',
  LARGE: 'Large',
  ENTERPRISE: 'Enterprise',
};

/** Size → StatusBadge tone, so the list/detail badge reads in one consistent color language. */
export const COMPANY_SIZE_TONE: Record<CompanySize, StatusTone> = {
  STARTUP: 'neutral',
  SMALL: 'info',
  MEDIUM: 'info',
  LARGE: 'success',
  ENTERPRISE: 'success',
};

/** Human labels for the backend `CompanyStatus` enum (ADR-0022 — tenant lifecycle). */
export const COMPANY_STATUS_LABELS: Record<CompanyStatus, string> = {
  ACTIVE: 'Active',
  SUSPENDED: 'Suspended',
};

/** Status → StatusBadge tone: an active tenant reads calm-green, a suspended one reads as an alarm. */
export const COMPANY_STATUS_TONE: Record<CompanyStatus, StatusTone> = {
  ACTIVE: 'success',
  SUSPENDED: 'error',
};

export const COMPANY_SIZE_OPTIONS: SelectOption[] = (
  Object.entries(COMPANY_SIZE_LABELS) as [CompanySize, string][]
).map(([value, label]) => ({ value, label }));

// Logo upload constraints moved to `@/constants/uploads` (COMPANY_LOGO_CONSTRAINT) — two features
// upload logos, so the mirror of the backend's CompanyLogoConstraints lives at app level.
